import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
const tagRe = /<([a-zA-Z0-9]+)>([\s\S]*?)<\/\1>|<([a-zA-Z0-9]+)\/>/;
const voidElementTags = {
  area: true,
  base: true,
  br: true,
  col: true,
  embed: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true,
  menuitem: true
};
function formatElements(value) {
  let elements = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const uniqueId = makeCounter(0, "$lingui$");
  const parts = value.split(tagRe);
  if (parts.length === 1) return value;
  const tree = [];
  const before = parts.shift();
  if (before) tree.push(before);
  for (const [index, children, after] of getElements(parts)) {
    let element = typeof index !== "undefined" ? elements[index] : void 0;
    if (!element || voidElementTags[element.type] && children) {
      if (!element) {
        console.error("Can't use element at index '".concat(index, "' as it is not declared in the original translation"));
      } else {
        console.error("".concat(element.type, " is a void element tag therefore it must have no children"));
      }
      element = React.createElement(React.Fragment);
    }
    if (Array.isArray(element)) {
      element = React.createElement(React.Fragment, {}, element);
    }
    tree.push(React.cloneElement(element, {
      key: uniqueId()
    },
    // format children for pair tags
    // unpaired tags might have children if it's a component passed as a variable
    children ? formatElements(children, elements) : element.props.children));
    if (after) tree.push(after);
  }
  return tree.length === 1 ? tree[0] : tree;
}
function getElements(parts) {
  if (!parts.length) return [];
  const [paired, children, unpaired, after] = parts.slice(0, 4);
  const triple = [paired || unpaired, children || "", after];
  return [triple].concat(getElements(parts.slice(4, parts.length)));
}
const makeCounter = function () {
  let count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  return () => "".concat(prefix, "_").concat(count++);
};
function TransNoContext(props) {
  const {
    render,
    component,
    id,
    message,
    formats,
    lingui: {
      i18n,
      defaultComponent
    }
  } = props;
  const values = _objectSpread({}, props.values);
  const components = _objectSpread({}, props.components);
  if (values) {
    Object.keys(values).forEach(key => {
      const index = Object.keys(components).length;
      if (typeof values[key] === "string" || typeof values[key] === "number") {
        return;
      }
      components[index] = /* @__PURE__ */React.createElement(React.Fragment, null, values[key]);
      values[key] = "<".concat(index, "/>");
    });
  }
  const _translation = i18n && typeof i18n._ === "function" ? i18n._(id, values, {
    message,
    formats
  }) : id;
  const translation = _translation ? formatElements(_translation, components) : null;
  if (render === null || component === null) {
    return translation;
  }
  const FallbackComponent = defaultComponent || RenderFragment;
  const i18nProps = {
    id,
    message,
    translation,
    children: translation
    // for type-compatibility with `component` prop
  };

  if (render && component) {
    console.error("You can't use both `component` and `render` prop at the same time. `component` is ignored.");
  } else if (render && typeof render !== "function") {
    console.error("Invalid value supplied to prop `render`. It must be a function, provided ".concat(render));
  } else if (component && typeof component !== "function") {
    console.error("Invalid value supplied to prop `component`. It must be a React component, provided ".concat(component));
    return React.createElement(FallbackComponent, i18nProps, translation);
  }
  if (typeof render === "function") {
    return render(i18nProps);
  }
  const Component = component || FallbackComponent;
  return React.createElement(Component, i18nProps, translation);
}
const RenderFragment = _ref => {
  let {
    children
  } = _ref;
  return /* @__PURE__ */React.createElement(React.Fragment, null, children);
};
export { TransNoContext as T };